module.exports = __webpack_public_path__ + "static/media/next-arrow.f27b0984.svg";